<template>
  <div style="color:white;" >
    <v-container class="my-14">



      <v-card class="pt-5" style="max-width:600px; margin: auto;">
        <v-card-title>
          <h2 class="mtfont">Register for a New Account</h2>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              type="email"
              label="*email"
              v-model="username"
            />
            <v-text-field
              type="Password"
              label="*password"
              v-model="password"
            />
            <v-text-field
              type="Password"
              label="*verify password"
              v-model="rePassword"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="black" class="mtfont" v-on:click="$router.push({name: 'Login'})">Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="black"
            style="color: #fecb39;"
            class="mtfont"
            v-on:click="attemptRegistration"
          >Register</v-btn>
        </v-card-actions>
      </v-card>



    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Register',
  data: () => ({
    username: '',
    password: '',
    rePassword: ''
  }),
  methods: {
    attemptRegistration(event) {
      if(!this.password || !this.rePassword || !this.username) return alert('All Fields Must be Filled In');
      if(this.password !== this.rePassword) return alert('Passwords Must Match');

      this.$store.dispatch('registerUser',{
        "username": this.username,
        "password": this.password
      }).then(response => {
        if(response === "SUCCESS") this.$router.push({name: 'Admin'});
        else alert('Invalid Username or Password!');
      });
    }
  }
}
</script>

<style scoped>

</style>